import { useModalCustomOptions } from "#/shared/hooks"
import { MezoModalProps } from "#/shared/types"
import { StepperModal } from "#/ui/Modal"

import ManageStakeFlowProvider, {
  useManageStakeFlowContext,
} from "./ManageStakeFlowContext"
import ManageStep from "./ManageStep"
import ReviewAndSignStep from "./ReviewAndSignStep"
import StakeSuccessfullyUpdatedStep from "./StakeSuccessfullyUpdatedStep"
import UpdateStakeStep, { UPDATE_STAKE_STEP_TITLE } from "./UpdateStakeStep"

function ManageStakeStepperModal(props: MezoModalProps) {
  const { manageType } = useManageStakeFlowContext()

  const { stakeId } = useModalCustomOptions<{
    stakeId: string
  }>()

  return (
    <StepperModal
      {...props}
      initialContextValue={{ amount: "", stakeId }}
      steps={[
        {
          title: "Manage",
          withCloseButton: true,
          component: ManageStep,
        },
        {
          ...(manageType && { title: UPDATE_STAKE_STEP_TITLE[manageType] }),
          withCloseButton: true,
          component: UpdateStakeStep,
        },
        {
          title: "Review and sign",
          withCloseButton: true,
          component: ReviewAndSignStep,
        },
        {
          title:
            manageType === "increase-amount"
              ? "Successfully staked"
              : "Success",
          withCloseButton: true,
          withBackButton: false,
          component: StakeSuccessfullyUpdatedStep,
        },
      ]}
    />
  )
}
export default function ManageStakeModal(props: MezoModalProps) {
  return (
    <ManageStakeFlowProvider>
      <ManageStakeStepperModal {...props} />
    </ManageStakeFlowProvider>
  )
}
